import { Injectable } from '@angular/core';
import { PendoService } from '@app/modules/analytics';
import { isLocalDevEnv } from '@app/modules/shared/utilities/utilities';

export enum TrackedEvents {
  TIMELINE = 'Timeline Hover',
  PATH = 'Path Hover'
}

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class EventTrackingFacade {
  constructor(private trackingService: PendoService) {}

  trackEvent(event: string, metadata?: any): void {
    if (isLocalDevEnv()) {
      console.log(`EventTrackingFacade.trackEvent - EVENT: ${event} METADATA:`, metadata);
    } else {
      // TODO: move this logic into zonar-ui-analytics
      if (window?.pendo) {
        this.trackingService.trackEvent(event, metadata);
      } else {
        window.setTimeout(() => {
          this.trackEvent(event, metadata);
        }, 10);
      }
    }
  }
}
